import { v4 as uuidv4 } from 'uuid';

export function ProductHighlights(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductHighlights',
		componentId: uuidv4(),
		props: Object.assign(
			{
				type: 'collection',
			},
			props,
		),
		childrenComponents: childrenComponents.length
			? childrenComponents
			: [
					{
						componentName: 'ProductHighlightWrapper',
						componentId: uuidv4(),
						props: {
							blockClass: `highlight-wrapper-${props.blockClass || ''}`,
						},
						childrenComponents: [
							{
								componentName: 'ProductHighlightText',
								componentId: uuidv4(),
								props: {
									message: '{highlightName}',
									blockClass: `highlight-text-${props.blockClass || ''}`,
								},
								childrenComponents: [],
							},
						],
					},
				],
	};
}
